import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["internalButton", "externalButton", "internalField", "externalField", "typeFieldValue", "emailField"];

  static values = {
    type: String,
  }

  connect() {
    if (this.typeValue == "internal_team") {
      this.selectInternal();
    } else {
      this.selectExternal();
    }
  }

  selectInternal() {
    this.typeValue = "Team";
    this.internalButtonTarget.classList.add("bg-primary", "text-white", "font-medium");
    this.internalButtonTarget.classList.remove("bg-secondary-light", "text-gray-500", "text-black");
    this.externalButtonTarget.classList.remove("bg-primary","text-white", "font-medium");
    this.externalButtonTarget.classList.add("bg-secondary-light", "text-black");

    this.internalFieldTarget.classList.remove("hidden");
    this.externalFieldTarget.classList.add("hidden");

    this.typeFieldValueTarget.value = "internal_team";

    this.emailFieldTarget.classList.add("hidden");
  }

  selectExternal() {
    this.typeValue = "ExternalTeam";
    this.externalButtonTarget.classList.add("bg-primary", "text-white", "font-medium");
    this.externalButtonTarget.classList.remove("bg-secondary-light", "text-gray-500", "text-black");
    this.internalButtonTarget.classList.remove("bg-primary", "text-white", "font-medium");
    this.internalButtonTarget.classList.add("bg-secondary-light", "text-black");

    this.internalFieldTarget.classList.add("hidden");
    this.externalFieldTarget.classList.remove("hidden");

    this.typeFieldValueTarget.value = "external_team";

    this.emailFieldTarget.classList.remove("hidden");
  }

}